import { Component, computed, input, output } from '@angular/core';
import { ButtonSeverity } from 'primeng/types/button';

type SeverityAlias = 'secondary' | 'success' | 'info' | 'warning' | 'warn' | 'danger' | 'help' | 'primary' | 'contrast' | '';
type BadgeSeverityAlias = 'secondary' | 'success' | 'info' | 'warning' | 'warn' | 'danger' | 'help' | 'primary' | 'contrast';

@Component({
  selector: 'app-primeng-button',
  templateUrl: './primeng-button.component.html',
  styleUrls: ['./primeng-button.component.scss'],
  standalone: false,
})
export class PrimengButtonComponent {
  type = input<'button' | 'submit' | 'reset'>('button');
  name = input<string>('');
  label = input<string>('');
  icon = input<string>('');
  iconPos = input<'left' | 'right' | 'top' | 'bottom'>('left');
  loading = input<boolean>(false);
  loadingIcon = input<string>('');
  disabled = input<boolean>(false);
  severity = input<SeverityAlias>('');
  text = input<boolean>(false);
  rounded = input<boolean>(false);
  outlined = input<boolean>(false);
  plain = input<boolean>(false);
  raised = input<boolean>(false);
  size = input<'small' | 'large' | ''>('');
  title = input<string>('');
  styleClass = input<string>('');
  badge = input<string>('');
  badgeSeverity = input<BadgeSeverityAlias>('secondary');
  value = input<string>('');

  onClick = output<Event>();

  normalizedSeverity = computed<ButtonSeverity>(() => {
    const sev = this.severity();
    return sev ? ((sev === 'warning' ? 'warn' : sev) as ButtonSeverity) : undefined;
  });

  normalizedBadgeSeverity = computed<ButtonSeverity>(() => {
    const bSev = this.badgeSeverity();
    return (bSev === 'warning' ? 'warn' : bSev) as ButtonSeverity;
  });

  private lastClickTime = 0;

  handleClick(event: Event) {
    if (this.disabled() || this.loading()) {
      return;
    }
    const now = Date.now();
    if (now - this.lastClickTime < 60) {
      return;
    }
    this.lastClickTime = now;
    this.onClick.emit(event);
  }
}
